import React, { FC, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, Input, Button, Dropdown, Menu } from "antd";
import { ReactSVG } from "react-svg";
import { useDispatch, useSelector } from "react-redux";
import { LOGOUT_USER, LOGOUT } from "reducers/authReducer";
import { DownOutlined } from "@ant-design/icons";
import {
  EditBioModal,
  EditPrivacyModal,
  EditPaymentModal,
  EditPermissionsModal,
  EditNotificationModal,
} from "components/Modals";
import Clock from "common/Clock";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import { GET_USER_INFO, GET_USER_AGGREGATE_INFO } from "reducers/authReducer";
import VerifyPinModal from "components/Modals/VerifyPinModal";
import { REQUEST_VERIFICATION_CODE } from "reducers/authReducer";
import { RootState } from "reducers/rootReducer";

const HeaderPanel: FC<{socket: ISocket;}> = ({socket}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { userInfo } = useSelector((state: RootState) => state.auth);
  const [editModalOpen, setEditModalOpen] = useState<boolean>(false);
  const [name, setName] = useState<string>("");
  const [image, setImage] = useState();
  const [editPrivacyModalOpen, setEditPrivacyModalOpen] =
    useState<boolean>(false);
  const [editPaymentModalOpen, setEditPaymentModalOpen] =
    useState<boolean>(false);
  const [confirmationDialog, setConfirmationDialog] = useState<boolean>(false);
  const [editPermissionsModalOpen, setEditPermissionsModalOpen] =
    useState<boolean>(false);
  const [editNotificationModalOpen, setEditNotificationModalOpen] =
    useState<boolean>(false);
  const [verifyPinModalOpen, setVerifyPinModalOpen] = useState<boolean>(false);

  useEffect(() => {
    // console.log('get user info here')
    // dispatch(GET_USER_INFO());
  }, []);

  useEffect(() => {
    // console.log(userInfo);
    if (userInfo) {      
      const firstname = userInfo.firstName || "";
      const lastname = userInfo.lastName || "";
      if (!firstname && !lastname) {
        setName("");
        return;
      }
      const name = firstname + " " + lastname;
      setName(name);
      setImage(userInfo?.profileImage?.urls?.original?.url ?? "/images/users/user.png");
    } else {
      setName("");
    }
  }, [userInfo]);

  const handlePinVerification = (status: boolean) => {
    setVerifyPinModalOpen(false);
    if (status) {
      setEditPrivacyModalOpen(true);
    }
  };

  const handlePrivacyClick = () => {
    const email = localStorage.getItem("email");
    const phone = localStorage.getItem("phone");
    let payload = {};
    if (email) {
      Object.assign(payload, { email });
    }
    if (phone) {
      Object.assign(payload, { email: phone });
    }
    dispatch(REQUEST_VERIFICATION_CODE(payload));
    setVerifyPinModalOpen(true);
  };

  const menu = (
    <ul className="user-dropdown">
      {userInfo && userInfo.email &&
        <React.Fragment>
          <li onClick={() => setEditModalOpen(true)}>
            <ReactSVG src="/images/male-icon.svg" />
            <span className="ml-4">Edit Bio</span>
          </li>
          <li onClick={handlePrivacyClick}>
            <ReactSVG
              src="/images/privacy-icon.svg"
              className="popup-icon"
              style={{ marginLeft: "-12px" }}
            />
            <span className="ml-3">Privacy</span>
          </li>
          <li onClick={() => setEditNotificationModalOpen(true)}>
            <ReactSVG
              src="/images/message-white-icon.svg"
              className="popup-icon"
              style={{ marginLeft: "-12px" }}
            />
            <span className="ml-3">Notification</span>
          </li>
          <li onClick={() => setEditPaymentModalOpen(true)}>
            <ReactSVG
              src="/images/payment-icon.svg"
              className="popup-icon payment "
              style={{}}
            />
            <span className="ml-4">Payment</span>
          </li>
          <li onClick={() => setEditPermissionsModalOpen(true)}>
            <ReactSVG
              src="/images/permission-icon.svg"
              className="popup-icon"
              style={{}}
            />
            <span className="ml-3">Permission</span>
          </li>
        </React.Fragment>
      }
      {(!userInfo || !userInfo.email) &&
        <li onClick={() => {
          history.push('auth/register')
        }}>
          <ReactSVG src="/images/male-icon.svg" />
          <span className="ml-3">Register</span>
        </li>
      }
      <li onClick={() => setConfirmationDialog(true)}>
        <ReactSVG src="/images/logout-icon.svg" />
        <span className="ml-3">Logout</span>
      </li>

    </ul>
  );
  return (
    <div className="header-panel mr-4">
      <ReactSVG src="/images/logo-icon.svg" className="logo-icon" />
      <div className="d-flex">
        <ReactSVG src="/images/calendar-icon.svg" className="clock-icon" />
        <Clock />
        <Dropdown overlay={menu} placement="bottomRight" trigger={["click"]}>
          <div className="user-avatar d-flex">
            <img src={image || "/images/users/user.png"} style={{borderRadius: '50%'}}/>
            <p className="mx-2">{name}</p>
            <DownOutlined style={{ fontSize: 14 }} />
          </div>
        </Dropdown>
      </div>
      {editModalOpen && (
        <EditBioModal onClose={() => setEditModalOpen(false)} />
      )}
      {editPrivacyModalOpen && (
        <EditPrivacyModal onClose={() => setEditPrivacyModalOpen(false)} />
      )}
      {editPaymentModalOpen && (
        <EditPaymentModal socket={socket} onClose={() => setEditPaymentModalOpen(false)} />
      )}
      {editPermissionsModalOpen && (
        <EditPermissionsModal
          onClose={() => setEditPermissionsModalOpen(false)}
        />
      )}
      {editNotificationModalOpen && (
        <EditNotificationModal
          onClose={() => setEditNotificationModalOpen(false)}
        />
      )}
      {verifyPinModalOpen && (
        <VerifyPinModal
          onClose={() => setVerifyPinModalOpen(false)}
          onVerification={handlePinVerification}
        />
      )}
      {confirmationDialog && (
        <ConfirmationModal
          handleConfirm={() => dispatch(LOGOUT())}
          message={"Do you really want to logout?"}
          onClose={() => setConfirmationDialog(false)}
        />
      )}
    </div>
  );
};

export default HeaderPanel;
